__turbopack_context__.v({
  "instructor-anchor-offset": "instructor-card-module-scss-module__I4Puja__instructor-anchor-offset",
  "instructor-card": "instructor-card-module-scss-module__I4Puja__instructor-card",
  "instructor-image": "instructor-card-module-scss-module__I4Puja__instructor-image",
  "instructor-info": "instructor-card-module-scss-module__I4Puja__instructor-info",
  "instructor-name": "instructor-card-module-scss-module__I4Puja__instructor-name",
  "instructor-title": "instructor-card-module-scss-module__I4Puja__instructor-title",
});
